import { ArrowRightIcon } from '@10xLabs/react-web/components/Icons/ArrowRight'
import { Column } from '@10xLabs/react-web/components/Column'
import { ReactElement } from 'react'
import styled from 'styled-components'

const StyledArrowRightIcon = styled(ArrowRightIcon)`
  fill: #5d5c70;
  width: 24px;
  height: 14px;
`

const ArrowLeftIcon = styled(StyledArrowRightIcon)`
  transform: rotate(180deg);
`

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const BothWay = (): ReactElement => {
  return (
    <Grid>
      <StyledArrowRightIcon />
      <ArrowLeftIcon />
    </Grid>
  )
}

export const OneWay = (): ReactElement => {
  return (
    <div>
      <StyledArrowRightIcon />
    </div>
  )
}

export const SplitColumn = styled(Column)<{ noMargin?: boolean }>`
  flex: 0.1;
  align-self: center;
  text-align: center;
  ${({ noMargin }): string | undefined => {
    if (noMargin) {
      return `
        margin: 0;
      `
    }
  }}
`

export const Pointer = styled.div`
  cursor: pointer;
`
